<template>
  <div class="forum-container">
    <div class="back-route" @click.stop="user.role.toLowerCase() === 'tutor' ? router.push(`./`) : router.replace(`/course/${route.params.courseId}/module/${route.params.moduleId}`)"><i class="material-icons">keyboard_arrow_left</i><span>Volver al módulo</span></div>
    <!-- <h2>Foro <span v-if="contentLoaded">Fecha de entrega: {{content.displayEndDate}}</span></h2> -->


    <div class="module_muro__title">
      <span class="module_muro__title-activity">{{ $t('course.modules.forum.TITLE') }}</span>
      <p v-if="contentLoaded" class="module_muro__title-date">
        <span
        v-if="content && content.isMandatory"
        ><i class="material-icons-outlined">error</i> Actividad obligatoria</span>
        <span
        v-else
        ><i class="material-icons-outlined">error</i> Actividad optativa</span>
        <span v-if="content.displayEndDate">{{ $t('global.DELIVERY_DATE') }} {{content.displayEndDate}}</span>
      </p>
    </div>

    <div class="forum__activity">
      <template v-if="contentLoaded">
        <div v-html="content.data.Data"></div>
      </template>
      <Loader v-else />
    </div>

    <div class="forum">
      <template v-if="forumLoaded">
        <div class="forum__tutor-name">
          <div v-if="forum.header.creatorPicture !== null" class="tutor-img">
            <img :src="getFile(forum.header.creatorPicture,'user')">
          </div>
          <div v-else class="tutor-img--letter" :style="{backgroundColor:randomColor(forum.header.creatorIdentifier)}">
            <span>{{forum.header.creatorName.charAt(0)}}</span>
          </div>
          <span>{{forum.header.creatorName}}</span>
        </div>
        <div class="forum__topic">
          <div class="forum__topic__subject">{{forum.header.subject}}</div>
          <div class="forum__topic__message" v-html="forum.header.message"></div>
        </div>

        <div class="forum__header">
          <div class="forum__header__actions">
            <button :disabled="content.courseIsFinished" :class="{'active':forum.header.isLikedByUser}" @click.stop="!forum.header.btnLikeDisabled ? likeUnlikeHeader() : ''"><i class="material-icons-outlined">favorite_border</i> {{$t('forum.actions.LIKE')}} ({{forum.header.likesQuantity}})</button>
            <!-- <div v-else @click.stop="!forum.header.btnLikeDisabled ? likeUnlikeHeader() : ''"><i class="material-icons">favorite</i>Ya no me gusta ({{forum.header.likesQuantity}})</div> -->
            <button :disabled="content.courseIsFinished" @click.stop="reply();forum.header.replying = true"><I class="material-icons-outlined">comment</I> {{$t('forum.actions.REPLY')}}</button>
          </div>
        </div>
        <div class="forum__new-comment" v-if="forum.header.replying">
          <vue-editor
          v-model="newCommentModel.comment"
          :editor-toolbar="customToolbar"
          :editorOptions="editorSettings"
          /> 
          <div class="forum__new-comment__files">
            <div class="file-name" v-for="(att, attIdx) in newCommentModel.attach" :key="attIdx">
              <span>{{att.originalFileName}}</span> 
              <i class="material-icons" @click.stop="newCommentModel.attach.splice(attIdx,1)">close</i> 
            </div>
          </div>
          <div class="forum__new-comment__actions">
            <div class="forum__new-comment__actions--container" >
              <div @change="uploadFile($event)" class="upload-file__container" >
                <label for="upload-file">{{$t('file.UPLOAD_FILE')}}<i class="material-icons">file_upload</i></label>
                <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" id="upload-file">
              </div>
              <button @click.stop="showPopUp = !showPopUp" @mouseover="!isMobile && setPopUpHover(true)" @mouseleave="!isMobile && setPopUpHover(false)"  >
                  <i class="material-icons-outlined" >info</i>
              </button>
              <HoverPopUp v-if="showPopUp" :content="$t('file.MAX_FILE_WEIGHT')" />
            </div>
            
            <div>
              <button class="btn-discard" @click.stop="forum.header.replying = false">{{ $t('global.DISCARD') }}</button>
              <button :disabled="newCommentModel.comment.trim().length === 0 && newCommentModel.attach.length === 0" class="btn-comment" @click.stop="newCommentModel.savingEdition ? ' ' : postComment()">{{ $t('global.COMMENT') }}</button>
            </div>
          </div>
        </div>

        <div v-if="content.courseIsFinished" class="courseIsFinished">
            <i class="material-icons">error</i>
            <span>
              <strong>{{ $t('course.status.COURSE_FINISHED') }}</strong><br/>
                <p>{{$t('forum.instructions.COURSE_FINISHED')}}</p>
            </span>
        </div>

        <div class="forum__comments" ref="scrollComponent">

          <div class="comment" v-for="(comment, index) in forum.comments" :key="index">

            <template v-if="!comment.isDeleted">

              <div class="comment__content">
                <div v-if="comment.userImage" class="comment__content__user-img" :style="{backgroundColor:randomColor(comment.userIdentifier)}">
                  <img :src="getFile(comment.userImage,'user')">
                </div>
                <div v-else class="comment__content__user-img--letter" :style="{backgroundColor:randomColor(comment.userIdentifier)}">
                  <span>{{comment.userName.charAt(0)}}</span>
                </div>
                <div class="comment__content__info">
                  <div class="comment__header">
                    <div>
                      <span>{{ comment.userName }}</span>
                      <span> - {{comment.whenCreated.quantity}} {{$t(`date.params.${comment.whenCreated.param}`)}} </span>
                    </div>
                    <i class="material-icons" v-if="!comment.modalEdit && comment.canEdit" @click.stop="comment.modalEdit = true;">more_horiz</i>
                  </div>
                  <div class="comment__comment" v-if="!comment.editing"> 
                    <div v-html="comment.comment" style="white-space: pre-line;"></div>
                    <div class="comment__attach" v-if="comment.attach.length">
                      <template v-for="(att,idx) in comment.attach" :key="idx">
                        <a :href="getFile(att.file, 'foroComment')" target="_blank">
                          <img v-if="att.contentType.includes('image')" :src="getFile(att.file,'foroComment')">
                        </a>
                      </template>
                      <template v-for="(att,idx) in comment.attach" :key="idx">
                        <a v-if="!att.contentType.includes('image')" :href="getFile(att.file,'foroComment')" target="_blank">
                          <i class="material-icons">attach_file</i><span>{{att.originalFileName}}</span>
                        </a>
                      </template>
                    </div>
                  </div>
                  <div v-if="comment.modalEdit" class="modal__edit-comment">
                    <i class="material-icons" @click.stop="editComment(index,'start')">edit</i>
                    <i class="material-icons" 
                    @click.stop="deleteCommentModel.id=comment.id;deleteCommentModel.idx=index;modalDelete=true; commentForDelete=comment">
                    delete</i>
                    <i class="material-icons" @click.stop="comment.modalEdit = false;">close</i>
                  </div>
                </div>
              </div>


              <div v-if="comment.editing">

                <div class="forum__new-comment">
                  <vue-editor
                  v-model="editCommentModel.comment"
                  :editor-toolbar="customToolbar"
                  :editorOptions="editorSettings"
                  /> 
                  <div class="forum__new-comment__files">
                    <div class="file-name" v-for="(att, attIdx) in editCommentModel.attach" :key="attIdx">
                      <span>{{att.originalFileName}}</span> 
                      <i class="material-icons" @click.stop="editCommentModel.attach.splice(attIdx,1)">close</i> 
                    </div>
                  </div>
                  <div class="forum__new-comment__actions">
                    <div class="forum__new-comment__actions--container"  > 
                      <div @change="uploadFile($event,true)" class="upload-file__container">
                        <label for="upload-file">{{$t('file.UPLOAD_FILE')}}<i class="material-icons">file_upload</i></label>
                        <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" id="upload-file">
                      </div>
                      <button @click.stop="showPopUp = !showPopUp" @mouseover="!isMobile && setPopUpHover(true)" @mouseleave="!isMobile && setPopUpHover(false)"  >
                        <i class="material-icons-outlined" >info</i>
                      </button>
                      <HoverPopUp v-if="showPopUp" :content="$t('file.MAX_FILE_WEIGHT')" />
                    </div>
                    <div>
                      <button class="btn-discard" @click.stop="comment.editing = false">{{$t('global.DISCARD')}}</button>
                      <button :disabled="editCommentModel.comment.trim().length === 0 && editCommentModel.attach.length === 0" class="btn-comment" @click.stop="editCommentModel.savingEdition ? ' ' : editComment(index,'end')">{{$t('global.SAVE')}}</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="comment__actions">
                <button :disabled="content.courseIsFinished" :class="{'active':comment.isLikedByUser}" @click.stop="!comment.btnLikeDisabled ? likeUnlikeComment(comment.id, index) : ''">{{$t('forum.actions.LIKE')}} ({{comment.likesQuantity}})</button>
                <button :disabled="content.courseIsFinished" @click.stop="reply();comment.replying = true;comment.seeReplies=true">{{$t('global.REPLY')}}</button>
                <div v-if="!comment.seeReplies" @click.stop="getCommentAnswers(comment.id,index, comment.repliesQuantity);comment.seeReplies = true">{{$t('global.SHOW_REPLIES')}} ({{comment.repliesQuantity}})</div>
                <div v-else @click.stop="comment.seeReplies = false">{{$t('global.HIDE_REPLIES')}} ({{comment.repliesQuantity}})</div>
              </div>

              <!-- Respondiendo -->
              <div class="forum__new-comment" v-if="comment.replying">
                <vue-editor
                v-model="newCommentModel.comment"
                :editor-toolbar="customToolbar"
                :editorOptions="editorSettings"
                />
                <div class="forum__new-comment__files">
                  <div class="file-name" v-for="(att, attIdx) in newCommentModel.attach" :key="attIdx">
                    <span>{{att.originalFileName}}</span> 
                    <i class="material-icons" @click.stop="newCommentModel.attach.splice(attIdx,1)">close</i> 
                  </div>
                </div> 
                <div class="forum__new-comment__actions">
                  <div class="forum__new-comment__actions--container" >
                    <div @change="uploadFile($event)" class="upload-file__container" >
                      <label for="upload-file">{{$t('file.UPLOAD_FILE')}}<i class="material-icons">file_upload</i></label>
                      <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" id="upload-file">
                    </div>
                    <button @click.stop="showPopUp = !showPopUp" @mouseover="!isMobile && setPopUpHover(true)" @mouseleave="!isMobile && setPopUpHover(false)"  >
                      <i class="material-icons-outlined" >info</i>
                    </button>
                    <HoverPopUp v-if="showPopUp" :content="$t('file.MAX_FILE_WEIGHT')" />
                  </div>

                  <div>
                    <button class="btn-discard" @click.stop="comment.replying = false">{{$t('global.DISCARD')}}</button>
                    <button :disabled="newCommentModel.comment.trim().length === 0 && newCommentModel.attach.length === 0" class="btn-comment" @click.stop="newCommentModel.savingEdition ? ' ' : postComment(comment.id)">{{$t('global.REPLY')}}</button>
                  </div>
                </div>
              </div>

            </template>
            <div v-else class="comment-deleted">
              <div class="comment-deleted__content">
                <span><i class="material-icons">error_outline</i> <i>{{$t('comments.COMMENT_HAS_BEEN_REMOVED')}}</i> </span>
                <i class="material-icons-outlined" v-if="user.permissions.includes('CURSO_FORO_TEMA_DEBATE')" @click.stop="comment.modalEdit = true;">more_horiz</i>
                <div v-if="comment.modalEdit" class="modal__edit-comment">
                    <i class="material-icons" 
                    @click.stop="deleteCommentModel.id=comment.id;deleteCommentModel.idx=index;modalDelete=true; commentForDelete=comment">
                    delete</i>
                    <i class="material-icons" @click.stop="comment.modalEdit = false;">close</i>
                </div>
              </div>
              <div class="comment__actions">
                <div v-if="!comment.seeReplies" @click.stop="getCommentAnswers(comment.id,index, comment.repliesQuantity);comment.seeReplies = true">{{ $t('global.SHOW_REPLIES') }} ({{comment.repliesQuantity}})</div>
                <div v-else @click.stop="comment.seeReplies = false">{{$t('global.HIDE_REPLIES')}} ({{comment.repliesQuantity}})</div>
              </div>
            </div>

            <div class="comment__replies" v-if="comment.seeReplies">
              <div class="comment" v-for="(reply, subIdx) in comment.replies" :key="subIdx">

                <div class="comment__content">
                  <div class="reply__line"><div></div><div></div></div>
                  <div v-if="reply.userImage" class="comment__content__user-img" :style="{backgroundColor:randomColor(reply.userIdentifier)}">
                    <img :src="getFile(reply.userImage,'user')">
                  </div>
                  <div v-else class="comment__content__user-img--letter" :style="{backgroundColor:randomColor(reply.userIdentifier)}">
                    <span>{{reply.userName.charAt(0)}}</span>
                  </div>
                  <div class="comment__content__info">
                    <div class="comment__header">
                      <div>
                        <span>{{ reply.userName }}</span>
                        <span> - {{reply.whenCreated.quantity}} {{$t(`date.params.${reply.whenCreated.param}`)}} </span>
                      </div>
                      <i class="material-icons" v-if="!reply.modalEdit && reply.canEdit" @click.stop="reply.modalEdit = true;">more_horiz</i>
                    </div>
                    <div class="comment__comment" v-if="!reply.editing"> 
                      <div v-html="reply.comment"></div>
                      <div class="comment__attach" v-if="reply.attach.length">
                        <template v-for="(att,idx) in reply.attach" :key="idx">
                          <a :href="getFile(att.file, 'foroComment')" target="_blank">
                            <img v-if="att.contentType.includes('image')" :src="getFile(att.file,'foroComment')">
                          </a>
                        </template>
                        <template v-for="(att,idx) in reply.attach" :key="idx">
                          <a v-if="!att.contentType.includes('image')" :href="getFile(att.file,'foroComment')" target="_blank">
                            <i class="material-icons">attach_file</i><span>{{att.originalFileName}}</span>
                          </a>
                        </template>
                      </div>
                    </div>
                    <div v-if="reply.modalEdit" class="modal__edit-comment">
                      <i class="material-icons" @click.stop="editComment(subIdx,'start',index)">edit</i>
                      <i class="material-icons" 
                      @click.stop="deleteCommentModel.id=reply.id;deleteCommentModel.idx=subIdx;deleteCommentModel.parentIdx=index;modalDelete=true;commentForDelete=reply">
                      delete</i>
                      <i class="material-icons" @click.stop="reply.modalEdit = false;">close</i>
                    </div>
                  </div>
                </div>

                <div v-if="reply.editing">
                  <div class="forum__new-comment">
                    <vue-editor
                    v-model="editCommentModel.comment"
                    :editor-toolbar="customToolbar"
                    :editorOptions="editorSettings"
                    />
                    <div class="forum__new-comment__files">
                      <div class="file-name" v-for="(att, attIdx) in editCommentModel.attach" :key="attIdx">
                        <span>{{att.originalFileName}}</span> 
                        <i class="material-icons" @click.stop="editCommentModel.attach.splice(attIdx,1)">close</i> 
                      </div>
                    </div>
                    <div class="forum__new-comment__actions">
                      <div class="forum__new-comment__actions--container" >
                          <div @change="uploadFile($event,true)" class="upload-file__container" >
                            <label for="upload-file">{{$t('file.UPLOAD_FILE')}}<i class="material-icons">file_upload</i></label>
                            <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" id="upload-file">
                          </div>
                          <button @click.stop="showPopUp = !showPopUp" @mouseover="!isMobile && setPopUpHover(true)" @mouseleave="!isMobile && setPopUpHover(false)"  >
                            <i class="material-icons-outlined">info</i>
                          </button>
                          <HoverPopUp v-if="showPopUp" :content="$t('file.MAX_FILE_WEIGHT')" />
                      </div>
                      <div>
                        <button class="btn-discard" @click.stop="reply.editing = false">{{$t('global.DISCARD')}}</button>
                        <button :disabled="editCommentModel.comment.trim().length === 0 && editCommentModel.attach.length === 0" class="btn-comment" @click.stop="editCommentModel.savingEdition ? ' ' : editComment(subIdx,'end',index)">{{ $t('global.SAVE') }}</button>
                      </div>
                    </div>
                  </div>  

                </div>
                <div class="comment__actions">
                  <button :disabled="content.courseIsFinished" :class="{'active': reply.isLikedByUser}" @click.stop="!reply.btnLikeDisabled ? likeUnlikeComment(reply.id,subIdx,index) : ''">{{$t('forum.actions.LIKE')}} ({{reply.likesQuantity}})</button>
                </div>
              </div>
            </div>
          </div>
          <Loader v-if="!newCommentsLoaded" />
        </div>
        
      </template>
    </div>
    
    <Modal v-if="modalDelete" :isOpen="modalDelete" @close="modalDelete=false;deleteCommentModel.id=null;deleteCommentModel.idx=null;deleteCommentModel.parentIdx=null">
        <div class="modal__content">
            <div class="modal__title">
                <h2>{{ $t('comments.WISH_DELETE_COMMENT') }}</h2>
            </div>
            <div class="modal__options">
                <button v-if="deleteCommentModel.parentIdx !== null" class="modal__options--cancel" @click="modalDelete=false;deleteCommentModel.id=null;deleteCommentModel.idx=null;deleteCommentModel.parentIdx=null">{{$t('global.CANCEL')}}</button>
                <button v-if="!commentForDelete.isDeleted" class="modal__options--deleteOnly" @click.stop="deleteComment(deleteCommentModel.id,deleteCommentModel.idx,deleteCommentModel.parentIdx);">{{ $t('comments.DELETE_COMMENT') }}</button>
                <button v-if="deleteCommentModel.parentIdx === null && commentForDelete.repliesQuantity > 0" class="modal__options--deleteAll" @click.stop="deleteComment(deleteCommentModel.id,deleteCommentModel.idx,deleteCommentModel.parentIdx, true)">{{ $t('comments.DELETE_THREAD') }}</button>
            </div>
        </div>
    </Modal>

    <Modal v-if="uploadingFile" :isOpen="uploadingFile" :closeButton="false">
        <div class="modal__fileUploading__content">
            <i class="material-icons-outlined modal__fileUploading__icon">cloud_upload</i>
            <h4 class="modal__fileUploading__title">{{ $t('file.uploading.TITLE') }}</h4>
            <p class="modal__fileUploading__message">{{ $t('file.uploading.MESSAGE') }}</p>
            <div class="modal__fileUploading__bar"></div>
        </div>
    </Modal>

    <Modal v-if="uploadErrorModal.open" :isOpen="uploadErrorModal.open" @close="uploadErrorModal.open = false">
        <div class="modal__content">
            <i class="material-icons-outlined modal__error--icon">cancel</i>
            <h4 class="modal__error--title">{{$t('file.uploading_error.TITLE')}}</h4>
            <p class="modal__error--message">{{$t('file.uploading_error.MESSAGE')}}</p>
            <div class="upload-file">
                <div @change="uploadFile($event)" class="upload-file__container">
                    <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" id="upload-file">
                    <label for="upload-file">{{$t('file.UPLOAD_FILE')}}<i class="material-icons">file_upload</i></label>
                </div>
            </div>
        </div>
    </Modal>

  </div>

</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { onMounted, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
import { computed, inject } from "@vue/runtime-core";
import storage from "@/plugins/azure-storage";
import { VueEditor, Quill } from "vue3-editor";
import HoverPopUp from "../../components/HoverPopUp.vue";
import Emoji from "quill-emoji/dist/quill-emoji";
import Modal from "../../components/Modal.vue";
import Loader from "../../components/Loader.vue";
import { useI18n } from "vue-i18n";
Quill.register("modules/emoji", Emoji);
export default {
  components: {
    VueEditor,
    HoverPopUp,
    Modal,
    Loader
},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const content = ref();
    const contentLoaded = ref(false);
    const user = computed(() => store.getters.manageUser_user);
    const forum = ref();
    const forumLoaded = ref(false);
    const formatDate = inject("formatDate");
    const getFile = inject("getFile");
    const newCommentModel = ref();
    const isMobile = ref(window.innerWidth < 870)
    const editCommentModel = ref();
    const showPopUp = ref(false)
    const uploadingFile = ref(false)
    const newCommentsLoaded = ref(true)
    const scrollComponent = ref(null)
    const uploadErrorModal = ref({
      open: false,
      editMode: false
    })
    const modalDelete = ref(false);
    const commentForDelete = ref() // Agrega los datos del comentario que se va a eliminar para no tener problemas (mostrar boton borrar comentario y borrar hilo)
    const userLeterColors = ['#ff6961','#77dd77','#d2bead','#84b6f4','#fdcae1', '#9bd3ae', '#a0d2f3', '#a788ab', '#bf9780', '#96c4c4', '#5086c1', '#bdbfbf'];
    const randomColor = (seed)  => {
      seed = (seed || '') + "xx";
      var charCodes = seed.split('').reduce(function(a, b, i) {
          return (i == 1 ? a.charCodeAt(0) : +a) + b.charCodeAt(0);
      });
      return userLeterColors[charCodes % userLeterColors.length]
    }

    const setPopUpHover = (value) => showPopUp.value = value
    const { t } = useI18n()

    function cleanNewCommentModel() {
      newCommentModel.value = {
        forumHeaderId: route.params.headerId,
        comment: '',
        attach: [],
        replies: [],
        relatedCommentId: null,
      };
    }

    async function uploadFile(event,editMode=false) {
      let fileAccepted = ['application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.ms-powerpoint','application/vnd.ms-powerpoint.presentation.macroEnabled.12','application/vnd.openxmlformats-officedocument.presentationml.presentation','application/pdf','image/png','image/jpeg','image/gif','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
      let fileIsOk = false
      uploadingFile.value = true
      let file = event.target.files[0];
      if(!file) return false;
      for (const ext of fileAccepted){
          if(ext === file.type) fileIsOk = true  // Si el tipo de arcivo es correcto, entonces permitira que se suba el archivo. (fileIsOk set in true)
      }
      if (file.size > 629145600 || !fileIsOk) {
        uploadErrorModal.value.open = true
        uploadErrorModal.value.editMode = editMode
        return false;
      }
      editMode
        ? editCommentModel.value.fileUploading = true
        : newCommentModel.value.fileUploading = true;
      try {
        uploadErrorModal.value.open = false
        let fileCDN = await storage.updateFile(file,'foroComment');
        if(editMode){
          editCommentModel.value.attach.push({file: fileCDN, originalFileName: file.name, contentType: file.type});
          editCommentModel.value.fileUploading = false;
          uploadingFile.value = false
        }else{
          newCommentModel.value.attach.push({file: fileCDN, originalFileName: file.name, contentType: file.type});
          newCommentModel.value.fileUploading = false;
          uploadingFile.value = false
        }
      } catch (error) {
        console.log(error);
        uploadErrorModal.value.open = true
        uploadErrorModal.value.editMode = editMode
        editMode
          ? editCommentModel.value.fileUploading = false
          : newCommentModel.value.fileUploading = false;
        uploadingFile.value = false
      }
    }

    async function postComment(relatedId = null) {
      if(newCommentModel.value.comment.trim().length === 0 && newCommentModel.value.attach.length === 0) return
      newCommentModel.value.savingEdition = true;
      newCommentModel.value.courseId = route.params.courseId;
      if(relatedId !== null){
        newCommentModel.value.relatedCommentId = relatedId;      
      }
      try {
        let req = await store.dispatch('forum_postComment',newCommentModel.value);
        //store.dispatch('reloadCourseTree',true);
        if(relatedId !== null) {
          if(!forum.value.comments.find(com => com.id == relatedId).replies){
            forum.value.comments.find(com => com.id == relatedId).replies = [];
          }
          forum.value.comments.find(com => com.id == relatedId).replying = false;
          forum.value.comments.find(com => com.id == relatedId).replies.splice(0, 0, req.data);
          forum.value.comments.find(com => com.id == relatedId).repliesQuantity++;
        }
        else { 
          forum.value.comments.splice(0,0,req.data);
          forum.value.header.replying = false;
          forum.value.header.repliesQuantity++;
        }
        cleanNewCommentModel();
      } catch (error) {
        console.log(error);
        store.dispatch("notifications_create", {text: t('comments.ERROR_SENDED')});
      } finally {
        newCommentModel.value.savingEdition = false;
      }
    }

    async function getCommentAnswers(id,index, repliesQuantity){
      let req = await store.dispatch('forum_commentAnswers',{courseId:route.params.courseId,commentId:id, rowsPerPage: repliesQuantity});
      forum.value.comments[index].replies = req.data.data;
    }

    function reply(){
      forum.value.comments.forEach(el=>el.replying=false);
      forum.value.header.replying = false;
      cleanNewCommentModel();
    }

    const deleteCommentModel = ref({
      id: null,
      idx: null,
      parentIdx: null
    })

    async function deleteComment(id,idx,parentIdx, all=false){
      modalDelete.value = false;
      let params = {
        commentId: id,
        deleteAll: all,
        courseId: route.params.courseId
      }
      try {
        await store.dispatch('forum_deleteComment',params);
        if(parentIdx !== null){
          forum.value.comments[parentIdx].replies.splice(idx,1);
          forum.value.comments[parentIdx].repliesQuantity--;
          if(forum.value.comments[parentIdx].isDeleted && forum.value.comments[parentIdx].repliesQuantity == 0){
            forum.value.comments.splice(parentIdx,1);
          }
        }else if(!all && forum.value.comments[idx].repliesQuantity){
          forum.value.comments[idx].isDeleted = true;
          forum.value.comments.repliesQuantity--;
        }
        else{
          forum.value.comments.splice(idx,1)
          forum.value.comments.repliesQuantity--;
        }
        store.dispatch('notifications_create',{text: t('comments.COMMENT_DELETED')})
      } catch (error) {
        store.dispatch('notifications_create',{text: t('comments.ERROR_DELETE_COMMENT')})
      } finally{
        deleteCommentModel.value = {id: null,idx: null,parentIdx: null}
      }
    }

    async function editComment(index, startEnd, parentIdx = null) {
      if(startEnd == 'start'){
        forum.value.comments.forEach(com =>{
          if(com.editing) { com.editing = false }
          if(com.replies){
            com.replies.forEach(rep => {
              if(rep.editing) { rep.editing = false }
            })
          } 
        })
        if(parentIdx == null){
          forum.value.comments[index].editing = true;
          editCommentModel.value = forum.value.comments[index];
        }
        else{
          forum.value.comments[parentIdx].replies[index].editing = true;
          editCommentModel.value = forum.value.comments[parentIdx].replies[index];
        }
      }
      if (startEnd == 'end') {
        if (editCommentModel.value.comment.trim().length === 0 && editCommentModel.value.attach.length === 0) return
        editCommentModel.value.savingEdition = true;
        try {
          editCommentModel.value.filesAreModified = true;
          await store.dispatch('forum_editComment',editCommentModel.value);
          parentIdx == null
            ? forum.value.comments[index].editing = false
            : forum.value.comments[parentIdx].replies[index].editing = false;   
        } catch (error) {
          store.dispatch('notifications_create',{text: t('comments.ERROR_EDIT_COMMENT')})
        } finally{
          editCommentModel.value.savingEdition = false;
        }
      }
    }

    async function likeUnlikeHeader(){
      forum.value.header.btnLikeDisabled = true;
      try {
        if(forum.value.header.isLikedByUser){
          await store.dispatch('forum_deleteLikeHeader',forum.value.header.id);
          forum.value.header.isLikedByUser = false;
          forum.value.header.likesQuantity--;
        }
        else{
          await store.dispatch('forum_postLikeHeader',forum.value.header.id);
          forum.value.header.isLikedByUser = true;
          forum.value.header.likesQuantity++;
        }
      } catch (error) {
        console.log(error)
        store.dispatch('notifications_create',{text:t('forum.errors.LIKE_HEADER')})
      }
      finally{
        forum.value.header.btnLikeDisabled = false;
      }
    }

    async function likeUnlikeComment(commentId,commentIdx,parentIdx=null){
      parentIdx !== null
        ? forum.value.comments[parentIdx].replies[commentIdx].btnLikeDisabled = true
        : forum.value.comments[commentIdx].btnLikeDisabled = true;
      try {
        if(parentIdx !== null){
          if(forum.value.comments[parentIdx].replies[commentIdx].isLikedByUser){
            await store.dispatch('forum_deleteLikeComment',commentId);
            forum.value.comments[parentIdx].replies[commentIdx].isLikedByUser = false;
            forum.value.comments[parentIdx].replies[commentIdx].likesQuantity--;
          }else{
            await store.dispatch('forum_postLikeComment',commentId);
            forum.value.comments[parentIdx].replies[commentIdx].isLikedByUser = true;
            forum.value.comments[parentIdx].replies[commentIdx].likesQuantity++;
          }
        }
        else{
          if(forum.value.comments[commentIdx].isLikedByUser){
            await store.dispatch('forum_deleteLikeComment',commentId);
            forum.value.comments[commentIdx].isLikedByUser = false;
            forum.value.comments[commentIdx].likesQuantity--;
          }else{
            await store.dispatch('forum_postLikeComment',commentId);
            forum.value.comments[commentIdx].isLikedByUser = true;
            forum.value.comments[commentIdx].likesQuantity++;
          }
        }
      }catch (error) {
        console.log(error);
        store.dispatch('notifications_create',{text:t('comments.ERROR_LIKE_COMMENT')});
      }finally{
        parentIdx !== null
          ? forum.value.comments[parentIdx].replies[commentIdx].btnLikeDisabled = false
          : forum.value.comments[commentIdx].btnLikeDisabled = false;
      }
    }

    const getData = async () => {
      // Si es la primera ves que pide informacion ...
      if (forum.value === undefined) {
        let res = await store.dispatch("forum_comments", { courseId: route.params.courseId, headerId: route.params.headerId, pageNumber: 0, rowsPerPage: 20 });
        forum.value = res.data
        forum.value.pageNumber = 0
        forumLoaded.value = true;
        return
      }
      if (forum.value.totalResults > forum.value.comments.length) {
        newCommentsLoaded.value = false
        let res = await store.dispatch('forum_comments', { courseId: route.params.courseId, headerId: route.params.headerId, pageNumber: forum.value.pageNumber + 1, rowsPerPage: 20  })
        forum.value.comments.push(...res.data.comments)
        forum.value.totalResults = res.data.totalResults
        forum.value.pageNumber++
        newCommentsLoaded.value = true
      }
    }

      const handleScroll = () => {
        if (newCommentsLoaded.value) {
          let element = scrollComponent.value
          if (element.getBoundingClientRect().bottom - 1 < window.innerHeight) {
            getData()
          }
        }
    }

    onMounted(async () => {
      let reqContent = await store.dispatch("courses_contents", route.params.contentId);
      content.value = reqContent.data;
      content.value.data = JSON.parse(content.value.data);
      content.value.data.Data = content.value.data.Data.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'');
      contentLoaded.value = true;
      window.addEventListener('resize', () => isMobile.value = window.innerWidth < 1000 )
      window.addEventListener('scroll', handleScroll)
      getData()
      isMobile.value = window.innerWidth < 1000
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      router,
      route,
      content,
      contentLoaded,
      forum,
      forumLoaded,
      formatDate,
      getFile,
      randomColor,
      showPopUp,
      user,
      uploadingFile,
      uploadErrorModal,
      modalDelete,
      newCommentModel,
      editCommentModel,
      commentForDelete,
      postComment,
      deleteComment,
      setPopUpHover,
      deleteCommentModel,
      editComment,
      reply,
      uploadFile,
      isMobile,
      scrollComponent,
      getCommentAnswers,
      likeUnlikeHeader,
      newCommentsLoaded,
      likeUnlikeComment,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }, { color: [] }, { background: [] },],
        ["emoji"]
      ],
      editorSettings: {
        modules: {
          "emoji-toolbar": true,
          "emoji-textarea": false,
          "emoji-shortname": false,
        },
      }
    };

  },
};
</script>

<style src="quill-emoji/dist/quill-emoji.css"></style>
<style lang="scss" scoped>
@import "@/styles/main.scss";

.dots{
  margin-left: 12px;
}

.modal{
  &__content{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    width: 691px;
  }
  &__error{
        &--icon{
            color: $red;
            font-size: 36px;
        }
        &--title{
            font-size: 18px;
        }
        &--message{
            font-size: 14px;
            font-weight: 400;
            width: 100%;
        }
    }
  &__fileUploading{
    &__content{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-direction: column;
        padding: 16px;
        width: 670px;
        .material-icons-outlined{
            color: #fff;
            font-size: 26px;
            padding: 16px;
            background: linear-gradient(180deg, #54C5C5 17.71%, #009696 100%);
            border-radius: 999px;
            margin-bottom: 12px;
        }
    }
    &__title{
        font-size: 18px;
        margin-bottom: 6px;
    }
    &__message{
        font-size: 14px;
        font-weight: 400;
    }
    &__bar{
        margin-top: 14px;
        margin-left: 25%;
        margin-right: 25%;
        width: 0%;
        height: 4px;
        background  : linear-gradient(270deg, #009696 0%, #DDDDDD 100%);
        border-radius: 999px;
        align-self: flex-start;
        animation: uploading 3s infinite ease-in;
        @keyframes uploading{
            0%{
                width: 0%;
            }
            50%{
                width: 50%;
            }
            100%{
                width: 0%;
            }
        }
    }
  }
}


.hover__container{
  position: absolute;
  bottom: 100%;
  left: 15%;
}

.back-route{
  width: fit-content;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 1px;
  font-weight: 600;
  font-size: 12px;
  color: $green;
  cursor: pointer;
  .material-icons{
      font-size: 17px;
  }
}

h2{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-size: 24px;
  line-height: 24px;
  span{
      font-size: 13px;
      line-height: 13px;
      color: $black;
  }
}

.forum {
  &__activity{
    margin: 8px 0;
    font-size: 18px !important;
    *{
      font-size: 18px !important;
    }
  }
  &__topic{
    padding-left: 8px;
    margin-bottom: 8px;
    &__subject{
      margin-bottom: 12px;
      font-weight: 600;
    }
    &__message{
      font-size: 14px;
      font-weight: 500;
    }
  }
  &__header {
    width: 100%;
    padding: 8px 0;
    margin-bottom: 16px;
    border-top: 1px solid #BDBDBD;
    border-bottom: 1px solid;
    &__actions{
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 32px;
      button{
        display: inline-flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
      }
      .material-icons-outlined{
        font-size: 18px;
      }
    }
  }
  &__tutor-name{
    margin: 14px 0;
    display: flex;
    align-items: flex-end;
    gap: 8px;
    .tutor-img{
      position: relative;
      width: 36px;
      height: 36px;
      flex-shrink: 0;
      border-radius: 100%;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &--letter{
        padding: 8px;
        position: relative;
        width: 36px;
        height: 36px;
        flex-shrink: 0;
        border-radius: 100%;
        text-align: center;
        span{ 
          width: fit-content;
          font-size: 14px;
          color: #fff;
          display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        }
      }
    } 
    >span{
      padding-bottom: 4px;
      font-size: 15px;
      font-weight: 600;
      color: $green;
    }
  }
  &__new-comment {
    @include flex-column;
    gap: 8px;
    width: 100%;
    .quillWrapper {
      width: 100%;
    }
    &__files{
      width: 100%;
      margin-bottom: 8px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 4px;
      .file-name{
        padding: 4px 16px;
        padding-right: 8px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        border: 1px solid #ccc;
        background: #f5f5f5;
        border-radius: 44px;
        color: $black;
        font-size: 13px;
        line-height: 16px;
        font-weight: 600;
        .material-icons{
          color: #333;
          font-size: 16px;
          line-height: 16px;
          cursor: pointer;
        }
      }      
    }
    &__actions{
      position: relative;
      width: 100%;
      height: fit-content;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media screen and (max-width: $bpSmall){
        flex-direction: column;
        gap: 6px;
      }
      &--container{
        display: flex;
        align-items: center;
        gap: 6px;
        .material-icons-outlined{
          color: $green;
        }
      }
      .upload-file__container{
        #upload-file{
          visibility: hidden;
          position: absolute;
          width: 0px;
          height: 0px;
          top: 0;
          left: 0;
        }
        label{
          padding: 4px 16px;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          border: 1px solid $green;
          border-radius: 44px;
          color: $green;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          .material-icons{
            color: $green;
            font-size: 22px;
          }
        }
      }
      >div:last-child{
        display: inline-flex;
        gap: 16px;
        @media screen and (max-width: $bpSmall){
          gap: 2px;
          flex-direction: column-reverse;
          width: 100%;
        }
        button{
          height: 32px;
          padding: 0 16px;
          border-radius: 44px;
          font-weight: 600;
          font-size: 13px;
          line-height: 16px;
        }
        .btn-comment {
          background-color: $green;
          color: #fff;
        }
        .btn-discard{
          color: $green;
        }
      }
    }
  }
  &__comments {
    width: 100%;
    margin-top: 12px;
    padding: 24px;
    @include flex-column;
    align-items: flex-start;
    //background-color: #dfd9d9;
    background-color: #fff;
    border-radius: 12px;
    overflow-x: auto;
    .comment {
      width: 100%;
      max-width: 100%;
      padding: 6px;
      
      &__content{
        display: flex;
        align-items: center;
        gap: 5px;
        @media screen and (max-width: $bpSmall){
          gap: 2px;
        }
        &__user-img{
          position: relative;
          width: 42px;
          height: 42px;
          flex-shrink: 0;
          border-radius: 100%;
          overflow: hidden;
          @media screen and (max-width: $bpSmall){
            width: 28px;
            height: 28px; 
          }
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          &--letter{
            padding: 8px;
            position: relative;
            width: 42px;
            height: 42px;
            flex-shrink: 0;
            border-radius: 100%;
            text-align: center;
            @media screen and (max-width: $bpSmall){
              padding: 2px;
              width: 28px;
              height: 28px;
            }
            span{ 
              width: fit-content;
              line-height: 26px;
              font-size: 16px;
              color: #fff;
            }
          }
        } 
        &__info{
          position: relative;
          width: fit-content;
          min-width: 310px;
          padding: 6px 14px 8px 14px;
          flex-shrink: 1;
          @include flex-column;
          align-items: flex-start;
          background-color: #f5f5f5;
          border-radius: 12px;
          @media screen and (max-width: $bpSmall){
            min-width: calc(100% - 32px);
            max-width: calc(100% - 32px);
          }
          .comment__header{
            width: 100%;
            display: flex;
            justify-content: space-between;
            >div{
              span:first-child{
                //white-space: nowrap;
                font-size: 13px;
                font-weight: 600;
                color: $green;
                @media screen and (max-width: $bpSmall) {
                    font-size: 12px;
                }
              }
              span:last-child{
                font-size: 11px;
                font-weight: 500;
                color: $black;
                @media screen and (max-width: $bpSmall) {
                    font-size: 10px;
                }
              }
            }
            .material-icons{
              cursor: pointer;
              line-height: 22px;
            }
          }
          .modal__edit-comment{
            position: absolute;
            top: 3px;
            right: 2px;
            padding: 3px 6px;
            padding-left: 18px;
            display: flex;
            gap: 14px;
            background-color: #fff;
            border-radius: 12px;
            box-shadow: -1px 1px 4px 1px rgba(125,125,125,0.41);
            opacity: .7;
            i{
              font-size: 18px;
              cursor: pointer;
            }
            i:last-child{
              margin-left: 4px;
              color: black;
            }
          }
        }
      }
      &__comment{
        width: 100%;
        font-size: 13px;
        overflow-wrap: anywhere;
        @media screen and (max-width: $bpSmall){
          font-size: 11px;
        }
      }
      &__attach{
        width: 100%;
        height: fit-content;
        padding-top: 4px;
        a{
          display: inline-flex;
          align-items: center;
          gap: 1px;
          color: $green;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          @media screen and (max-width: $bpSmall){
            font-size: 11px;
          }
          span{
            text-decoration: underline;
          }
          .material-icons{
            color: $green;
            font-size: 17px;
          }
        }
        img{
          margin: 4px;
          max-height: 500px;
          max-width: 100%;
          object-fit: contain;
          border-radius: 2px;
        }
      }
      &__actions {
        padding-top: 1px;
        padding-left: 60px;
        display: flex;
        gap: 16px;
        > div, button {
          display: inline-flex;
          align-items: center;
          gap: 2px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          &:disabled{
            cursor: default;
          }
        }
      }
      &__replies{
        padding-top: 8px;
        padding-left: 18px;
        .comment{ 
          padding-left: 0;
          padding-top: 2px;
          border-left: 1px solid #bdbdbd;
          &__content{
            .reply__line{
              align-self: stretch;
              width: 20px;
              >div{
                height: 50%;
                &:first-child{
                  border-bottom: 1px solid #bdbdbd;
                }
              }
            }
          }
          &:last-child{
            padding-top: 0;
            border-left: none;
            .reply__line{
              >div{
                &:first-child{
                  border-left: 1px solid #bdbdbd;
                }
              }
            }
          }
          &__actions{
            padding-left: 84px;
          }
        }
      }
      .forum__new-comment{
        padding: 12px 0px;
      }

      &-deleted{
        margin-bottom: 4px;
        margin-top: 4px;
        &__content{
          width: fit-content;
          margin-left: 0px;
          padding: 6px 14px 8px 14px;
          display: flex;
          align-items: center;
          gap: 4px;
          background-color: #f5f5f5;
          border-radius: 12px;
          font-size: 13px;
          font-weight: 600;
          color: #939393;
          position: relative;
          span{
            display: flex;
            align-items: center;
            gap: 4px;
          }
          .modal__edit-comment{
            position: absolute;
            top: 3px;
            right: 8px;
            padding: 3px 6px;
            display: flex;
            gap: 6px;
            background-color: #fff;
            border-radius: 12px;
            box-shadow: -1px 1px 4px 1px rgba(125,125,125,0.41);
            i{
              font-size: 18px;
              cursor: pointer;
            }
            i:last-child{
              margin-left: 4px;
              color: black;
            }
          }
          .material-icons-outlined{
            margin-left: 6px;
            font-size: 18px;
            cursor: pointer;
            color: $black;
          }
          .material-icons{
            font-size: 18px;
          }

        }
        .comment__actions{
          padding-left: 16px;
          width: 100%;
        }
      }
    }
  }
}

.active{
  color: $green;
  font-weight: 600 !important;
}

.modal{
    &__content{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px;
    }
    &__title{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 18px;
        p{
            font-size: 14px;
            text-align: center;
        }
        h2{
            font-size: 20px;
            font-weight: 700;
            color: $black;
        }
        i{
            color: $green;
            padding: 8px;
            font-size: 20px;
            background-color: rgba($color: $green, $alpha: .3);
            border-radius: 999px;
        }
    }
    &__options{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 18px;
        @media screen and (max-width: 470px){
            flex-direction: column;
            gap: 6px;
        }
        &--deleteAll{
            font-weight: 4s00;
            font-size: 16px;
            color: #fff;
            background-color: $green;
            padding: 12px 24px;
            border-radius: 44px;
            width: 180px;
        }
        &--deleteOnly{
            font-weight: 400;
            font-size: 16px;
            color: $green;
            background-color: inherit;
            border: 1px solid $green;
            padding: 12px 24px;
            border-radius: 44px;
            width: 180px;
       } 
    }
}

@media screen and (max-width: $bpBig){
  .forum{
    &__comments{
      padding: 16px 0;
      .comment__actions{
        div{
          font-size: 11px;
        }
      }
      .comment__replies  .comment,.reply__line>div{
        border: none !important;
        .comment__actions{
          padding-left: 62px;
        }
      }
    }
  }
}

button:disabled{
  opacity: .4;
  cursor: default;
}


</style>